export { default } from './ThumbsUpFill'
